import { SWReactIcons } from "@similarweb/icons";
import type { ITooltipProps } from "@similarweb/ui-components";
import { Tooltip } from "@similarweb/ui-components";

type InfoTooltipProps = Omit<ITooltipProps, "children"> & {
    className?: string;
};

const InfoTooltip = (props: InfoTooltipProps) => {
    const { className, ...rest } = props;

    return (
        <div
            className={className}
            data-automation="info-icon-tooltip"
        >
            <Tooltip {...rest}>
                <div>
                    <SWReactIcons
                        iconName="info"
                        size="xs"
                    />
                </div>
            </Tooltip>
        </div>
    );
};

export default InfoTooltip;
